<template>
	<div>
		<div v-if="name">
			<h1>Ensemble</h1>
			<b-form inline>
				<b-button variant="link" v-on:click="inverse()"
					><i class="fas fa-exchange-alt"></i
				></b-button>
				<b-input-group prepend="Nom">
					<b-form-input v-model="name_element"></b-form-input>
				</b-input-group>
				<b-input-group prepend="Version">
					<b-form-input v-model="version"></b-form-input>
				</b-input-group>
				<b-button v-b-modal="'modal' + id">Charger</b-button>
				<b-button @click="save_db" :disabled="!version || !name"
					><i class="fas fa-save"></i
				></b-button>
				<b-button v-b-modal="'modal_file' + id">Fichier</b-button>
				<b-button v-b-modal="'modal_rename' + id">Renommer</b-button>
			</b-form>

			<br />

			<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
				<span>Nom</span>
				<v-select
					v-model="load_name"
					:options="names"></v-select>
				<span>Version</span>
				<v-select
					v-model="load_version"
					:options="versions"></v-select>
			</b-modal>

			<b-modal
				:hide-footer="true"
				:id="'modal_file' + id"
				title="Fichier">
				<b-file
					accept=".json"
					@change="load_file"
					placeholder="charger (fichier)"></b-file>
				<br /><br />
				<b-button @click="save(true)">sauvergarder (fichier)</b-button>
			</b-modal>

			<b-modal
				:hide-footer="true"
				:id="'modal_rename' + id"
				title="Renommer">
				<p>Nouveau nom</p>
				<b-input v-model="new_name"></b-input>
				<br />
				<b-button @click="rename">Rennomer</b-button>
			</b-modal>
		</div>

		<b-tabs content-class="mt-3">
			<b-tab :title="dataset_1" active>
				<div class="form-inline">
					Nom :&nbsp;<b-form-input v-model="dataset_1"></b-form-input>
					<br /><br />
				</div>
				<dataset
					@update="update"
					ref="set1"
					v-bind:dataset_id="'1'"></dataset>
			</b-tab>
			<b-tab :title="dataset_2">
				<div class="form-inline">
					Nom :&nbsp;<b-form-input v-model="dataset_2"></b-form-input>
					<br /><br />
				</div>
				<dataset
					@update="update"
					ref="set2"
					v-bind:dataset_id="'2'"></dataset>
			</b-tab>
			<b-tab title="Analyse">
				<ensemble-analyse
					:dataset_1_name="dataset_1"
					:dataset_2_name="dataset_2"
					@update="emit_update"
					ref="analyse"></ensemble-analyse>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
	var clone = require("clone");
	var util = require("util");

	import * as json2csv from "json2csv";
	import uniqueId from "lodash.uniqueid";

	import store from "../store";
	import utils from "../services/utils.js";
	import element from "../services/element.js";
	import ensemble_analyse from "../components/ensemble_analyse.vue";

	export default {
		name: "ensemble",
		components: {
			dataset: () => import("../components/dataset.vue"),
			"ensemble-analyse": ensemble_analyse,
		},
		props: {
			name: {
				default: true,
				type: Boolean,
			},
		},
		data() {
			return {
				dataset_1: "dataset 1",
				dataset_2: "dataset 2",
				name_ensemble: "ensemble",
				id: uniqueId(""),
				type: "",
				name_element: "",
				new_name: name,
				names: [],
				versions: [],
				version: "",
				load_name: "",
				load_version: "",
			};
		},
		mounted: async function () {
			if (store.state.user.rules && !store.state.user.rules.ensemble) {
				this.$router.push({ name: "profile" });
			}
			this.type = "ensemble";
		},
		watch: {
			index: {
				async handler() {},
			},
			type: {
				async handler() {
					this.set_name();
				},
			},
			load_name: {
				async handler() {
					var elements = await element.getby_libelle(
						this.load_name,
						this.type
					);
					elements = elements.element;

					this.versions = [];
					for (var i = 0; i < elements.length; i++) {
						if (i == 0) {
							if (
								this.load_version &&
								this.load_version == elements[i].version
							)
								await this.load_db();
							this.load_version = elements[i].version;
						}
						this.versions.push(elements[i].version);
					}
				},
			},
			load_version: {
				async handler() {
					if (this.load_version) await this.load_db();
				},
			},
		},
		methods: {
			async rename() {
				console.log("rename");
				await element.rename(
					this.type,
					this.name_element,
					this.new_name
				);
				this.name_element = this.new_name;
				this.save_db();
			},
			async set_name() {
				var names = await element.getby_production(this.type);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].libelle);
				}
			},
			async save_db() {
				var data = await this.save(false);

				await element.save(
					this.name_element,
					this.version,
					data,
					this.type
				);
				await this.set_name();
			},
			async load_db() {
				document.body.style.cursor = "wait";
				var result = await element.load(
					this.load_name,
					this.load_version,
					this.type
				);
				this.name_element = this.load_name;
				this.version = this.load_version;
				await this.load(result);
				document.body.style.cursor = "default";
			},
			inverse() {
				var obj = {
					name_element: this.name_element,
					version: this.version,
					set2: this.$refs.set1.save(),
					set1: this.$refs.set2.save(),
					analyse: this.$refs.analyse.save(),
					dataset_2: this.dataset_1,
					dataset_1: this.dataset_2,
					name_ensemble: this.name_ensemble,
				};

				this.load(obj);
			},
			save(file = false) {
				var obj = {
					name_element: this.name_element,
					version: this.version,
					set1: this.$refs.set1.save(),
					set2: this.$refs.set2.save(),
					analyse: this.$refs.analyse.save(),
					dataset_1: this.dataset_1,
					dataset_2: this.dataset_2,
					name_ensemble: this.name_ensemble,
				};

				if (file)
					utils.saveToFile(
						JSON.stringify(obj),
						(this.name_element || "ensemble") + ".json"
					);
				else return obj;
			},
			async load(data) {
				var self = this;
				this.dataset_1 = data.dataset_1 || "dataset 1";
				this.dataset_2 = data.dataset_2 || "dataset 2";
				this.name_ensemble = data.name_ensemble || "ensemble";
				this.name_element = data.name_element || "";
				this.version = data.version || "";
				await this.$refs.analyse.load(data.analyse);
				await new Promise((resolve, reject) => {
					self.$nextTick(async function () {
						self.$nextTick(async function () {
							await this.$refs.set1.load(data.set1);
							await this.$refs.set2.load(data.set2);
							await this.$refs.analyse.analyse();
							await this.$refs.analyse.load(data.analyse);
							resolve();
						});
					});
				});
			},
			async load_file(event) {
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return function (e) {
						var data = JSON.parse(e.target.result);
						self.load(data);
					};
				})(file);

				reader.readAsText(file);
			},
			async update(dataset_id, data) {
				this.$refs.analyse.update(dataset_id, data);
			},
			get_data() {
				return this.$refs.analyse.get_data();
			},
			get_data_blob: async function () {
				var tabulator_data = this.$refs.analyse.get_data();
				var str_csv = json2csv.parse(tabulator_data, {
					fields: Object.keys(tabulator_data[0]),
					fieldNames: Object.keys(tabulator_data[0]),
				});

				return new Blob([str_csv], {
					type: "text/plain",
				});
			},
			get_data_files: async function (all_files = true) {
				if (!all_files) return [];

				var tabulator_data = this.$refs.analyse.get_data();

				var str_csv = json2csv.parse(tabulator_data, {
					fields: Object.keys(tabulator_data[0]),
					fieldNames: Object.keys(tabulator_data[0]),
				});

				return [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];
			},
			emit_update() {
				this.$emit("update", this.$refs.analyse.get_data());
			},
		},
	};
</script>
